import React from "react";

import logoImage from "../../assets/logos/logo.png";
import { defaultDomains } from "../../constants";
import { useGetCurrentBrandingQuery } from "../../features/branding/brandingApiSlice";

const Logo = () => {
	const domain = window.location.hostname;

	const { data: branding } = useGetCurrentBrandingQuery();

	if (!defaultDomains.includes(domain) && !branding?.logo) return null;

	return (
		<img
			src={branding?.logo ? branding.logo : logoImage}
			alt="CargoSeller"
			width="268"
			style={{
				objectFit: "contain",
			}}
		/>
	);
};

export default Logo;
